import { sendPasswordResetEmail } from "firebase/auth";
import React, { useState } from "react"; // Make sure your firebase is configured
import { auth } from "../../utilities/firebaseConfig";
import { Link, useNavigate } from "react-router-dom";
import loginbg from "../../assets/loginbg.jpg";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setError("");

    if (!email) {
      setErrorMessage("Please enter your email address.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setErrorMessage(
        "A password reset email has been sent to your email address. Please check your inbox."
      );
      setEmail(""); // Optionally clear the input
      navigate("/login");
    } catch (err) {
      console.error("Error sending password reset email:", err.message);
      setError(err.message);
    }
  };

  return (
    <div className='authbody'>
      <div className='authspagecnt'>
        <div className='signin_cnt'>
          <Link to='/' className='profixlogo'>
            ProfixExpress
          </Link>
          <div className='signincntbdy'>
            <h2 className='signin_title'>Forgot password</h2>
            <div className='thespace'></div>
            <p className='dnthaacnt'>
              Don’t worry, it happens to the best of us! We’ll email you a
              password reset link.
            </p>
            <div className='thespacee'></div>
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
            <div className='thespacee'></div>
            <form onSubmit={handlePasswordReset} className='theformcnt'>
              <div className='inputcnt'>
                <input
                  type='email'
                  placeholder='Email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className='thespacee'></div>
              <button className='thesigninbtn' type='submit'>
                Send Reset Email
              </button>{" "}
              <div className='thespace'></div>
              <p
                className='forgotpassworkclick'
                onClick={() => navigate("/login")}
              >
                Return to log in
              </p>
            </form>
          </div>
        </div>
        <div className='signinimagecnt'>
          <img className='signiimg' src={loginbg} alt='' />
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
